export default __webpack_public_path__ + "static/media/LebenswerkContact.75ee98b7.svg";